// MUI Components
import { Box, Button, Card, CardContent, Typography } from "@mui/material";

// Components
import CustomIcon from "components/CustomIcon";

import icons from "enums/icons";
import { useIntl } from "react-intl";
import useStyles from "./SummaryCard.styles";
import { ChipEntity } from "types";
import ChipsArray from "components/Domain/ChipsArray";

const SummaryCard = ({ children }: { children?: React.ReactNode }) => {
    const classes = useStyles();

    return (
        <Card className={classes.card}>
            <CardContent>
                <Box sx={{ position: "relative" }}>
                    <Box className={classes.gradientBox} />
                    {children}
                </Box>
            </CardContent>
        </Card>
    );
};

export const SummaryCardRow = ({
    config,
    onOpenModal,
}: {
    config: {
        name: string;
        icon: keyof typeof icons;
        items: ChipEntity[] | undefined;
    };
    onOpenModal?: () => Promise<void>;
}) => {
    const classes = useStyles();
    const intl = useIntl();

    const hasOpenModal = Boolean(onOpenModal);

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {config?.icon && <CustomIcon icon={icons[config.icon]} className={classes.summaryIcons} />}
                <Typography className={classes.sectionTitle}>{config?.name}</Typography>
            </Box>
            <Box sx={{ ml: "auto" }}>
                {!hasOpenModal && (
                    <Box sx={{ display: "flex", overflow: "hidden" }}>
                        <ChipsArray colorChip="primary" chipData={config?.items ? config?.items.slice(0, 4) : []} />
                    </Box>
                )}
                {hasOpenModal && (
                    <Button size="small" variant="text" onClick={onOpenModal} className={classes.button}>
                        {intl.formatMessage({ id: "dashboard.companySummary.button.seeMore" })}
                    </Button>
                )}
            </Box>
        </Box>
    );
};

export default SummaryCard;
